var _circle, _circle2, _circle3, _g, _path, _g2, _g3, _path2, _g4, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSimplecard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 29,
    viewBox: "0 0 24 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.6604,
    cy: 19.9026,
    r: 8.43091,
    fill: "url(#paint0_linear_8423_18055)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.6608,
    cy: 19.9025,
    r: 7.86885,
    stroke: "url(#paint1_linear_8423_18055)",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeDasharray: "1 1"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8423_18055",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 12,
    width: 15,
    height: 16
  }, _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.6603,
    cy: 19.9025,
    r: 7.30679,
    fill: "#F3FCF4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8423_18055)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_8423_18055)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 11.6603,
    cy: 19.9025,
    r: 7.30679,
    fill: "url(#paint2_radial_8423_18055)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M10.7878 27.8774L10.5781 11.8921H12.7618L12.5521 27.8774H10.7878Z",
    fill: "url(#paint3_linear_8423_18055)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M11.0129 27.7646L3.37988 15.7556L5.27097 14.6638L12.5409 26.8824L11.0129 27.7646Z",
    fill: "url(#paint4_linear_8423_18055)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M10.8312 26.8822L18.101 14.6636L19.9921 15.7554L12.3592 27.7644L10.8312 26.8822Z",
    fill: "url(#paint5_linear_8423_18055)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.4082,
    y: 20.7686,
    width: 14.5053,
    height: 6.38668,
    fill: "url(#paint6_linear_8423_18055)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_8423_18055)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 11.6603,
    cy: 19.9025,
    r: 7.30679,
    fill: "#D8D9D9",
    fillOpacity: 0.01
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.92032 7.03149H17.4259L20.104 10.0666L11.6731 11.4718L3.24219 10.0666L5.92032 7.03149Z",
    fill: "url(#paint7_radial_8423_18055)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_8423_18055)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.30074 4.3335H15.0455L9.31245 11.0782L3.24219 10.0665L8.30074 4.3335Z",
    fill: "url(#paint8_radial_8423_18055)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.98692 4.3335L4.92837 10.3475L3.24219 10.0665L8.30074 4.3335H9.98692Z",
    fill: "url(#paint9_linear_8423_18055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.62598 10.7972L9.31216 11.0782L15.0452 4.3335H13.359L7.62598 10.7972Z",
    fill: "url(#paint10_linear_8423_18055)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_8423_18055)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.0459 4.3335H8.30121L14.0342 11.0782L20.1045 10.0665L15.0459 4.3335Z",
    fill: "url(#paint11_radial_8423_18055)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3598 4.3335L18.4183 10.3475L20.1045 10.0665L15.0459 4.3335H13.3598Z",
    fill: "url(#paint12_linear_8423_18055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7207 10.7972L14.0345 11.0782L8.3015 4.3335H9.98768L15.7207 10.7972Z",
    fill: "url(#paint13_linear_8423_18055)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_8423_18055",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 9,
    width: 4,
    height: 5
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6842 13.3267C11.6842 13.3267 11.6842 13.3267 11.6842 13.3267L11.6842 13.3267C11.6842 13.3267 11.6842 13.3267 11.6842 13.3267C11.6842 13.3266 11.6842 13.3266 11.6842 13.3266L12.3804 13.0684C13.0112 12.8344 13.2709 12.0823 12.919 11.5089L11.6842 9.4974C11.6842 9.49739 11.6842 9.49739 11.6842 9.49739L11.6842 9.49735C11.6842 9.49734 11.6842 9.49734 11.6842 9.49735C11.6842 9.49735 11.6842 9.49735 11.6841 9.49735C11.6841 9.49734 11.6841 9.49734 11.6841 9.49735L11.6841 9.49739C11.6841 9.49739 11.6841 9.49739 11.6841 9.4974L10.4493 11.5089C10.0974 12.0823 10.3571 12.8344 10.9879 13.0684L11.6841 13.3266C11.6841 13.3266 11.6841 13.3266 11.6841 13.3267C11.6841 13.3267 11.6841 13.3267 11.6841 13.3267L11.6842 13.3267Z",
    fill: "url(#paint14_linear_8423_18055)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_8423_18055)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.6939 13.4067L13.5918 12.6273L11.6939 9.20434L11.6939 13.4067Z",
    fill: "url(#paint15_linear_8423_18055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6938 13.4067L9.7959 12.6273L11.6938 9.20434L11.6938 13.4067Z",
    fill: "url(#paint16_linear_8423_18055)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.94629 16.7335V15.1855H12.8383V23.9335H11.1103V16.7335H9.94629Z",
    fill: "url(#paint17_linear_8423_18055)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_8423_18055",
    x: 4.35352,
    y: 12.5957,
    width: 14.6133,
    height: 14.6135,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.725
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0941176 0 0 0 0 0.101961 0 0 0 0 0.105882 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_8423_18055"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_8423_18055",
    x: 4.35352,
    y: 12.5957,
    width: 14.6133,
    height: 14.6135,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.725
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0823529 0 0 0 0 0.231373 0 0 0 0 0.12549 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_8423_18055"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_8423_18055",
    x: 3.24219,
    y: 0.333496,
    width: 19.8037,
    height: 14.7446,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8423_18055"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_8423_18055",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_8423_18055",
    x: 0.300781,
    y: 0.333496,
    width: 19.8037,
    height: 14.7446,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8423_18055"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_8423_18055",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8423_18055",
    x1: 6.01169,
    y1: 13.4951,
    x2: 16.5503,
    y2: 26.7878,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF5DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFA365"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8423_18055",
    x1: 6.38871,
    y1: 13.9222,
    x2: 16.2248,
    y2: 26.3288,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#153B20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#176138"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_8423_18055",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.6603 19.9025) rotate(90) scale(7.30679)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#176138"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#153B20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_8423_18055",
    x1: 11.6699,
    y1: 11.8921,
    x2: 11.6699,
    y2: 27.8774,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3FCF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2EDED",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_8423_18055",
    x1: 5.40791,
    y1: 16.2922,
    x2: 11.7769,
    y2: 27.3235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3FCF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2EDED",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_8423_18055",
    x1: 17.964,
    y1: 16.292,
    x2: 11.5951,
    y2: 27.3233,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3FCF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2EDED",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_8423_18055",
    x1: 11.6609,
    y1: 23.538,
    x2: 11.6408,
    y2: 26.7597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#176138",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#176138"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_8423_18055",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.6731 9.25163) rotate(90) scale(2.22014 8.43091)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#176138"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#153B20"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_8423_18055",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(9.14383 7.70586) rotate(90) scale(3.37237 5.90164)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#176138"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#153B20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_8423_18055",
    x1: 4.35507,
    y1: 5.05518,
    x2: 7.99451,
    y2: 10.2035,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF5DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFA365"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_8423_18055",
    x1: 8.85015,
    y1: 5.14286,
    x2: 12.9575,
    y2: 10.8417,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF5DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFA365"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_8423_18055",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.2029 7.70586) rotate(90) scale(3.37237 5.90164)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#176138"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#153B20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_8423_18055",
    x1: 18.9916,
    y1: 5.05518,
    x2: 15.3522,
    y2: 10.2035,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF5DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFA365"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_8423_18055",
    x1: 14.4965,
    y1: 5.14286,
    x2: 10.3892,
    y2: 10.8417,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF5DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFA365"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_8423_18055",
    x1: 11.8229,
    y1: 10.5375,
    x2: 10.4768,
    y2: 11.9943,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D5D7D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2E3E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_8423_18055",
    x1: 13.2787,
    y1: 12.9024,
    x2: 10.9583,
    y2: 11.5807,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF5DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFA365"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_8423_18055",
    x1: 10.109,
    y1: 12.9024,
    x2: 12.4294,
    y2: 11.5807,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF5DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFA365"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_8423_18055",
    x1: 10.4235,
    y1: 16.2353,
    x2: 14.413,
    y2: 17.8989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF5DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFA365"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSimplecard);
export default __webpack_public_path__ + "static/media/simplecard.d525714f5b3e31cb97837ed10a66d62c.svg";
export { ForwardRef as ReactComponent };